import * as actions from "Actions";
import * as api from "Api";

import { getAllowedMediaTypes } from "Utils";

export const fetchMedias = ({ limit, conditions = [], order } = {}) => (
  dispatch,
  getState
) => {
  const { auth, params } = getState();
  const { token, navCommunity } = auth;
  const { lng } = params;

  const allowedMediaTypes = getAllowedMediaTypes(navCommunity);
  /*if (token === "") {
    return api.getClientCredential().done(resp => {
      const clientToken = resp.token.access_token;
      dispatch(actions.setAuthToken(clientToken));
      return dispatch(
        actions.fetchMedias(
          api.getMedias({
            token: clientToken,
            limit,
            conditions,
            lng,
            allowedMediaTypes,
            communityId: navCommunity.id
          })
        )
      );
    });
  }*/
  return dispatch(
    actions.fetchMedias(
      api
        .getMedias({
          token,
          limit,
          lng,
          conditions,
          allowedMediaTypes,
          communityId: navCommunity.id
        })
        .then(resp => {
          return { ...resp, data: { ...resp.data, order } };
        })
    )
  );
};

export const fetchInfiniteMediasByType = ({ type }) => (dispatch, getState) => {
  const { lng } = getState().params;
  const { auth } = getState();
  const { offset, limit } = getState().medias[type.toLowerCase()];
  const { token, navCommunity } = auth;

  const allowedMediaTypes = getAllowedMediaTypes(navCommunity);

  return dispatch(
    actions.fetchInfiniteMediasByType(type)(
      api.getMedias({
        token,
        type,
        limit,
        offset,
        lng,
        allowedMediaTypes,
        community: navCommunity
      })
    )
  );
};

export const fetchMediaInTheNews = type => (dispatch, getState) => {
  const { community } = getState().params.publicPortal;
  const { token, navCommunity } = getState().auth;
  return dispatch(
    actions.fetchMedias(
      api.getMediasInTheNews({
        token,
        community: navCommunity ? navCommunity : community
      })
    )
  );
};

/*export const fetchLatestByType = () => (dispatch, getState) => {
  const { lng } = getState().params;
  const { auth } = getState();
  const { token, navCommunity } = auth;

  if (token === "") {
    return api.getClientCredential().done(resp => {
      const clientToken = resp.token.access_token;
      dispatch(actions.setAuthToken(clientToken));
      return dispatch(
        actions.fetchMediasByType("TYPE")(
          api.getMediasByType({
            token: clientToken,
            lng,
            community: null
          })
        )
      );
    });
  }
  return dispatch(
    actions.fetchMediasByType("TYPE")(
      api.getMediasByType({
        token,
        lng,
        community: navCommunity /*, sourceToken*
      })
    )
  );
};


export const uploadMediaFiles = (
  files = []
  //docType = null,
  //mask = null,
  //logo = null,
  //logoPosition = null,
  //logoSize = null,
  //languages = ["FR", "EN", "NL"]
) => (dispatch, getState) => {
  // Add meta data to  files (id, upload progress, error, ...)
  const uploadingMedias = files.map((file, i) => ({
    id: `DROPPED-${i}-${performance.now()}`,
    file,
    progress: 0,
    error: null
  }));

  // Add uploading medias to store
  dispatch(actions.addUploadingMedias(uploadingMedias));

  // Upload the files
  uploadingMedias.forEach(media => {
    dispatch(
      saveMedia({
        file: media.file,
        /*docType,
        mask,
        logo,
        logoPosition,
        logoSize,
        languages,*
        onProgress: progress => {
          const { items } = getState().medias.uploading;

          let oldMedia = null;
          let oldMediaIndex = -1;

          for (let i = 0; i < items.length; i++) {
            if (items[i].id === media.id) {
              oldMedia = items[i];
              oldMediaIndex = i;
              break;
            }
          }

          if (!oldMedia || oldMediaIndex === -1) {
            return;
          }

          const newMedia = { ...oldMedia, progress };
          const newMedias = items.concat();
          newMedias[oldMediaIndex] = newMedia;

          dispatch(actions.setUploadingMedias(newMedias));
        }
      })
    )
      .then(() => {
        const { items } = getState().medias.uploading;
        const oldMedias = items.filter(m => m.id !== media.id);
        dispatch(actions.setUploadingMedias(oldMedias));
      })
      .catch(() => {
        const { items } = getState().medias.uploading;
        const oldMedias = items.filter(m => m.id !== media.id);
        dispatch(actions.setUploadingMedias(oldMedias));
      });
  });
};

export const saveMedia = ({
  id,
  file,
  titleFR,
  titleEN,
  titleNL,
  descriptionFR,
  descriptionEN,
  descriptionNL,
  altFR,
  altEN,
  altNL,
  copyrightFR,
  copyrightEN,
  copyrightNL,
  tags,
  creator,
  taggedUsers,
  isPrivate,
  mediaStatus,
  overrideMainImage = false,
  onProgress,
  docType,
  mask,
  logo,
  logoPosition,
  logoSize,
  width,
  height,
  languages
} = {}) => (dispatch, getState) => {
  const { token, navCommunity } = getState().auth;
  const { lng } = getState().params;

  return dispatch(
    actions.saveMedia(
      api.saveMedia({
        token,
        lng,
        id,
        file,
        titleFR,
        titleEN,
        titleNL,
        descriptionFR,
        descriptionEN,
        descriptionNL,
        altFR,
        altEN,
        altNL,
        copyrightFR,
        copyrightEN,
        copyrightNL,
        community: navCommunity,
        onProgress,
        tags,
        creator,
        taggedUsers,
        isPrivate,
        mediaStatus,
        overrideMainImage,
        docType,
        mask,
        logo,
        logoPosition,
        logoSize,
        width,
        height,
        languages
      })
    )
  );
};*/



// WEBPACK FOOTER //
// ./src/actions/thunks/media.js